import { Injectable } from '@angular/core';
import { MortgageApiService } from '@api-new/mortgageservice/index';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

export enum RepresentativeExampleType {
  MORTGAGE = 'MORTGAGE',
  SMART_SEARCH = 'SMART_SEARCH',
}

interface RepresentativeExampleState {
  isLoading: boolean;
  representativeExample: string;
}

const initialRepresentativeExampleState: RepresentativeExampleState = {
  isLoading: false,
  representativeExample: '',
};

@Injectable()
export class RepresentativeExampleStore extends ComponentStore<RepresentativeExampleState> {
  constructor(private readonly mortgageApiService: MortgageApiService) {
    super(initialRepresentativeExampleState);
  }

  // SELECTORS ---------------------------------------------------------------------------------------------------------
  readonly selectRepresentativeExample$ = this.select((state) => state.representativeExample);
  readonly selectIsLoading$ = this.select((state) => state.isLoading);
  // EFFECTS -----------------------------------------------------------------------------------------------------------
  readonly getRepresentativeExample = this.effect((request$: Observable<any>) =>
    request$.pipe(
      tap(() => this.setIsLoadingRepresentativeExample(true)),
      switchMap((request) =>
        (Object.keys(request).includes('mortgageId')
          ? this.mortgageApiService.HTTP_CP_GetMortgageDealRepresentativeExample(request)
          : this.mortgageApiService.HTTP_CP_GetSmartSearchDealRepresentativeExample(request)
        ).pipe(
          tapResponse(
            ({ representativeExample }) => this.setRepresentativeExample({ representativeExample }),
            (e) => console.error(e),
          ),
        ),
      ),
    ),
  );
  // UPDATERS ----------------------------------------------------------------------------------------------------------
  private setIsLoadingRepresentativeExample = this.updater((state, isLoading: boolean) => ({
    ...state,
    isLoading,
  }));
  private setRepresentativeExample = this.updater((state, { representativeExample }: { representativeExample: string }) => ({
    ...state,
    representativeExample,
    isLoading: false,
  }));
}
